import ProductCategoryCrud from './ProductCategoryCrud'
export {ProductCategoryCrud}
export default ProductCategoryCrud
